<template>
<div>
  <h2 class="display-1 mt-5"> {{ $t('faq.heading') }}</h2>

  <template v-for="(item, index) in $t('faq.items')">

    <h2 class="my-5" :key="'heading_' + index" >{{ item.title }}</h2>

    <v-expansion-panels :key="'panel_' + index">
      <v-expansion-panel
        v-for="(item, index) in item.items"
        :key="'question_' + index"
      >
        <v-expansion-panel-header class="primary--text text-subtitle-1">
          {{ item.question}}
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <div v-html="item.answer"></div>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </template>
</div>
</template>

<script>
export default {
  data() {
    return {
      questions: [
        {
          question: 'Example question 1?',
          answer: 'Quisque velit nisi, pretium ut lacinia in, elementum id enim. Donec sollicitudin molestie malesuada.'
        },
        {
          question: 'Example question 2?',
          answer: 'Proin eget tortor risus. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Donec velit neque, auctor sit amet aliquam vel, ullamcorper sit amet ligula. Lorem ipsum dolor sit amet, consectetur adipiscing elit.'
        },
        {
          question: 'Example question 3?',
          answer: 'Vestibulum ac diam sit amet quam vehicula elementum sed sit amet dui. Donec sollicitudin molestie malesuada.Donec rutrum congue leo eget malesuada. Vivamus suscipit tortor eget felis porttitor volutpat.'
        },
        {
          question: 'Example question 4?',
          answer: 'Quisque velit nisi, pretium ut lacinia in, elementum id enim. Donec sollicitudin molestie malesuada.'
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
// .v-expansion-panel-content{
//   display: block;
//   padding: measure(s)
// }

</style>
